import React from 'react';
import { connect } from 'react-redux';
import { LOCAL_KEYS } from '../../constants/localStorageKeys';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';
import { PAGE_ROUTES } from '../../constants/pageRoutes';
import { addDaysToDate } from '../../constants/util';
import { onDestinationFailedValidation } from '../destination-autosuggest/actions';

const mapStateToProps = state => ({
  search: state.Search,
});

export const adjustCheckInCheckoutDates = (newFilters) => {
  if (!newFilters.dates.from && !newFilters.dates.to)
    newFilters.dates = undefined;

  return newFilters;
}

class GoToSearch extends React.Component {

  constructor(props) {
    super(props);

    this.canGoToSearch = this.canGoToSearch.bind(this);
    this.dispatchErrors = this.dispatchErrors.bind(this);
    this.saveSearchFilters = this.saveSearchFilters.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
  }

  dispatchErrors() {
    const { dispatch } = this.props;
    const { geometry } = this.props.search.filters;

    if (!geometry.lat || !geometry.lng)
      dispatch(onDestinationFailedValidation("Enter a location"));
  }

  canGoToSearch = () => {
    const { geometry } = this.props.search.filters;

    if (!geometry.lat || !geometry.lng) {
      return false;
    }

    return true;
  }

  saveSearchFilters = () => {
    const { filters } = this.props.search;
    const newFilters = adjustCheckInCheckoutDates({ ...filters });

    localStorage.setItem(LOCAL_KEYS.FILTER_VALUES, JSON.stringify(newFilters));
  }

  goToSearch = () => {
    if (!this.canGoToSearch()) {
      this.dispatchErrors();
      return;
    }

    this.saveSearchFilters();
    window.location.href = `/app/#${PAGE_ROUTES.SEARCH}`;
  }

  render() {
    return (
      <div>
        <button type="button" className="btn primary" onClick={this.goToSearch}>Let's Go</button>
      </div >
    )
  }
}

export default connect(mapStateToProps)(GoToSearch);
